import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { ThemeProvider, createTheme, CssBaseline } from '@mui/material';
import Navbar from './components/navbar';
import Home from './components/home';
import About from './components/about';
import Pricing from './components/pricing';
// import Pricing from './components/pricing-future'; // Reserved for future use
import Privacy from './components/privacy';
import Terms from './components/terms';
import StarterWebsites from './components/starter-websites';
import ClientIntake from './components/client-intake';
import Footer from './components/footer';
import DemosHub from './demos/DemosHub';
import InteriorDemo from './demos/InteriorDemo';
import CafeDemo from './demos/CafeDemo';
import FitnessDemo from './demos/FitnessDemo';
import DentalDemo from './demos/DentalDemo';
import ConstructionDemo from './demos/ConstructionDemo';
import HomestayDemo from './demos/HomestayDemo';

const theme = createTheme({
  palette: {
    primary: {
      main: '#075A8C',
      dark: '#063B5B',
      light: '#DDF3F5',
    },
    secondary: {
      main: '#20B8B5',
      dark: '#118E8C',
      light: '#DDF8F7',
    },
    background: {
      default: '#F7FAFC',
      paper: '#FFFFFF',
    },
    text: {
      primary: '#102A3A',
      secondary: '#5F7280',
    },
  },
  typography: {
    fontFamily: '"Inter", "Segoe UI", "Helvetica Neue", Arial, sans-serif',
    button: {
      fontWeight: 700,
    },
    h1: {
      fontSize: '3.5rem',
      fontWeight: 800,
      letterSpacing: '-0.045em',
    },
    h2: {
      fontSize: '2.5rem',
      fontWeight: 800,
      letterSpacing: '-0.035em',
    },
    h3: {
      fontSize: '2rem',
      fontWeight: 500,
    },
  },
  shape: {
    borderRadius: 12,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 10,
          boxShadow: 'none',
          textTransform: 'none',
        },
      },
    },
  },
});

const AppContent = () => {
  const location = useLocation();
  const isImmersiveDemo = location.pathname.startsWith('/demos/');

  return (
    <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', overflowY: 'auto' }}>
      {!isImmersiveDemo && <Navbar />}
      <main style={{ flexGrow: 1 }}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/starter-websites" element={<StarterWebsites />} />
          <Route path="/start-website" element={<ClientIntake />} />
          <Route path="/client-intake" element={<ClientIntake />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/demos" element={<DemosHub />} />
          <Route path="/demos/interior" element={<InteriorDemo />} />
          <Route path="/demos/cafe" element={<CafeDemo />} />
          <Route path="/demos/fitness" element={<FitnessDemo />} />
          <Route path="/demos/dental/*" element={<DentalDemo />} />
          <Route path="/demos/construction/*" element={<ConstructionDemo />} />
          <Route path="/demos/homestay/*" element={<HomestayDemo />} />
        </Routes>
      </main>
      {!isImmersiveDemo && <Footer />}
    </div>
  );
};

const App = () => {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <AppContent />
      </Router>
    </ThemeProvider>
  );
};

export default App;
